import React from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { dictionary } from '../../../dictionary';

const PriceListDialog = ({ visible, onHide }) => {
  const rowClassName = (rowData) => {
    return {
      'price-list-category-row': rowData.isCategory,
    };
  };

  const bodyTemplate = (field) => {
    return (rowData) => {
      const isBold = rowData.boldFields && rowData.boldFields.includes(field);
      return <span style={{ fontWeight: isBold ? 'bold' : 'normal' }}>{rowData[field]}</span>;
    };
  };

  const secondLangBody = (rowData) => {
    if (rowData.isCategory && rowData.secondLanguage) {
      return <span style={{ fontWeight: 'bold' }}>{rowData.secondLanguage}</span>;
    }
    return rowData.secondLanguage;
  };

  const llideroBody = (rowData) => {
    const isBold = rowData.boldFields && rowData.boldFields.includes('llidero');
    return <span style={{ whiteSpace: 'pre-wrap', fontWeight: isBold ? 'bold' : 'normal' }}>{rowData.llidero}</span>;
  };

  return (
    <Dialog
      header={dictionary.esp_price_list_title}
      visible={visible}
      onHide={onHide}
      className="esp-price-list-dialog"
    >
      <DataTable
        value={dictionary.esp_price_list_data}
        size="small"
        stripedRows
        showGridlines
        emptyMessage={dictionary.esp_price_list_empty}
        rowClassName={rowClassName}
        scrollable
        scrollHeight="65vh"
      >
        <Column field="module" header={dictionary.esp_price_list_col_module} style={{ minWidth: '12%' }} />
        <Column
          field="llidero"
          header={dictionary.esp_price_list_col_llidero}
          body={llideroBody}
          style={{ minWidth: '22%' }}
        />
        <Column field="eld2" header={dictionary.esp_price_list_col_eld2} body={bodyTemplate('eld2')} />
        <Column
          field="secondLanguage"
          header={dictionary.esp_price_list_col_second_lang}
          body={secondLangBody}
          style={{ textAlign: 'center', minWidth: '10%' }}
        />
        <Column
          field="welearning"
          header={dictionary.esp_price_list_col_welearning}
          body={bodyTemplate('welearning')}
        />
        <Column
          field="welearningEld2"
          header={dictionary.esp_price_list_col_welearning_eld2}
          body={bodyTemplate('welearningEld2')}
        />
      </DataTable>
    </Dialog>
  );
};

export default PriceListDialog;
